export class IdViewModel {
    ids:number[];
    cols:string;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/view-model/id.viewModel.ts